import React from 'react';

const Divider = () => {
  return <hr className='w-full h-0.5 border-t-0 bg-ghost-white' />;
};

export default Divider;
